module.exports = __webpack_public_path__ + "media/icons/sprzedaz@2x-88ef8ce1.png";